// import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import Separator from "@components/CustomTypography/Separator/Separator"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import Badges from "@jsons/badges.json"
import CompanyData from "@jsons/company.json"
import CustomerStories from "@jsons/customerStories.json"
import CompanyBadgesSection from "@pages/Company/CompanyBadgesSection/CompanyBadgesSection"
import CompanyCustomersSection from "@pages/Company/CompanyCustomersSection/CompanyCustomersSection"
import CompanyHistorySection from "@pages/Company/CompanyHistorySection/CompanyHistorySection"
import CompanyIntroSection from "@pages/Company/CompanyIntroSection/CompanyIntroSection"
import CompanyProductSlider from "@pages/Company/CompanyProductSlider/CompanyProductSlider"
import React from "react"

const company = () => {
	const pageData = getTranslatedPageData(CompanyData, true, true)
	const AdvancedSideAsset = getValueOrThrow(pageData.AdvancedSideAsset)

	const translatedBadges = getPosts("BadgesModule", {data: Badges})
	const stories = getPosts("CustomerStoriesModule", {
		data: CustomerStories,
	})

	return (
		<>
			<HeadMeta
				meta={pageData.metaData}
				customPath={"/about-us/company"}
			/>

			<FullWidthHeader
				data={{
					title: pageData.heroData?.[0].title,
					subtitle: pageData.heroData?.[0].subtitle,
				}}
				position={"left"}
			/>
			<CompanyIntroSection
				intro={AdvancedSideAsset[0]}
				data={AdvancedSideAsset[1]}
				counts={getValueOrThrow(pageData.AdvancedSideAsset?.[2])}
			/>

			<CompanyHistorySection data={AdvancedSideAsset[3]} />
			<Separator size={64} />
			<CompanyProductSlider data={AdvancedSideAsset[4]} />
			<Separator size={128} />

			<CompanyBadgesSection
				badges={translatedBadges}
				data={AdvancedSideAsset[5]}
			/>

			<CompanyCustomersSection
				data={AdvancedSideAsset[6]}
				stories={stories}
			/>
		</>
	)
}

export default company
